export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/50 via-background-50 to-accent-100/40"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium mb-4 md:mb-5">
              <i className="ri-fire-line text-sm"></i>
              实时追踪 · 全网首发
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-[2.65rem] font-heading text-foreground-950 leading-snug mb-3 md:mb-4">
              51吃瓜网今日吃瓜资源
              <br className="lg:hidden" />
              <span className="text-primary-500"> — 全网最新吃瓜内容聚合平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-4 md:mb-5 leading-relaxed">
              随时随地，一手掌握最新最全的吃瓜热点
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-7 max-w-[600px] lg:max-w-none space-y-2">
              <p>
                51吃瓜网今日吃瓜资源是国内领先的娱乐资讯聚合平台，智能监控50+主流内容源，7×24小时实时追踪明星动态、综艺热点、影视资讯、时尚八卦等全网最新吃瓜内容。无论你是想获取51吃瓜官网全网最新入口，还是下载51吃瓜轻量版或51吃瓜APP客户端，亦或是通过手机端网页版稳定访问官方入口地址，这里都能满足你的需求。
              </p>
              <p className="hidden sm:block">
                当前正值2026暑期档收官阶段，各大综艺节目和影视剧集进入最后冲刺期，娱乐圈热点事件密集爆发，正是吃瓜的黄金时节。本站已为你整理好近期最热话题和5 1吃瓜下载最新地址，助你不错过任何一条精彩内容。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                <span><strong className="text-primary-600">日均更新 200+</strong> 条</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>覆盖 <strong className="text-accent-600">50+</strong> 内容源</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span><strong className="text-secondary-700">7×24</strong> 小时值守</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#features');
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                立即访问
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#app');
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-300 text-foreground-700 font-semibold text-sm rounded-md hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-cloud-2-line text-lg"></i>
                APP下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-[480px] shrink-0">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20digital%20collage%20of%20Chinese%20entertainment%20news%20and%20social%20media%20themes%2C%20neon%20lit%20smartphone%20screens%20displaying%20trending%20headlines%2C%20colorful%20notification%20bubbles%20in%20dark%20atmospheric%20space%2C%20warm%20coral%20and%20magenta%20gradient%20lighting%2C%20modern%20editorial%20design%20with%20geometric%20abstract%20shapes%2C%20cyberpunk%20meets%20pop%20culture%20aesthetic%2C%20high%20contrast%20visual%20with%20dramatic%20shadows%2C%20clean%20composition%20suitable%20for%20hero%20section&width=900&height=720&seq=hero-main-visual&orientation=portrait"
                alt="51吃瓜网今日吃瓜资源 - 全网最新吃瓜内容聚合平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}